var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        'grid items-center grid-rows-3 investors row-gap-0 col-gap-5 py-6 p-output w-a4w bg-output-gray-200',
        {
            'grid-cols-3':
                _vm.investors.length % 2 !== 0 || _vm.investors.length === 8,
            'grid-cols-2':
                _vm.investors.length % 2 === 0 && _vm.investors.length !== 8,
            'grid-rows-3': _vm.investors.length !== 3,
            'grid-rows-4': _vm.investors.length === 3
        }
    ]},_vm._l((_vm.investors),function(investor,index){return _c('div',{key:index,class:[
            'w-full p-6 mx-auto bg-white border h-11/12 border-output-primary',
            {
                'col-span-3 row-span-2 text-3xl ': _vm.investors.length === 1,
                'col-span-1 row-span-2 text-2xl ': _vm.investors.length === 2,
                'row-span-2': _vm.investors.length === 3
            }
        ]},[_c('h4',{class:[
                'text-output-secondary',
                {
                    'text-xl': _vm.investors.length >= 3,
                    'text-3xl': _vm.investors.length === 1
                }
            ]},[(investor.sex === 'femme')?_c('i',{staticClass:"las la-female la-lx"}):_c('i',{staticClass:"las la-male la-lx"}),_vm._v(" "+_vm._s(investor.lastName + " " + investor.firstName)+" ")]),_c('hr',{staticClass:"w-6/12 h-px bg-output-primary"}),_c('div',{staticClass:"grid grid-cols-2"},[_c('div',{class:[
                    'pb-1',
                    {
                        ' col-span-2': _vm.investors.length < 3
                    }
                ]},[_c('h4',{staticClass:"inline pr-1 text-output-secondary"},[_vm._v("Age :")]),_c('p',{staticClass:"inline"},[_vm._v(_vm._s(_vm.age(investor.birthday)))])]),_c('div',{class:[
                    'pb-1',
                    {
                        ' col-span-2': _vm.investors.length <= 3
                    }
                ]},[_c('h4',{staticClass:"inline pr-1 text-output-secondary"},[_vm._v("CIN :")]),_c('p',{staticClass:"inline"},[_vm._v(_vm._s(investor.CIN))])]),_c('div',{class:[
                    'pb-1',
                    {
                        ' col-span-2': _vm.investors.length <= 3
                    }
                ]},[_vm._m(0,true),_c('p',{staticClass:"inline"},[_vm._v(_vm._s(investor.phone))])]),_c('div',{class:[
                    'pb-1',
                    {
                        ' col-span-2': _vm.investors.length <= 3
                    }
                ]},[_vm._m(1,true),_c('p',{staticClass:"inline"},[_vm._v(_vm._s(investor.email))])]),_c('div',{staticClass:"col-span-2 pb-1"},[_c('h4',{staticClass:"inline pr-1 text-output-secondary"},[_vm._v("Adresse :")]),_c('p',{staticClass:"inline"},[_vm._v(_vm._s(investor.address))])]),_c('div',{staticClass:"col-span-2 pb-1"},[_c('h4',{staticClass:"inline pr-1 text-output-secondary"},[_vm._v(" Formation : ")]),_c('p',{staticClass:"inline"},[_vm._v(_vm._s(investor.niveauDeFormation))])]),_c('div',{staticClass:"col-span-2 pb-1"},[_c('h4',{staticClass:"inline pr-1 text-output-secondary"},[_vm._v(" Expérience Professionnelle : ")]),_c('p',{staticClass:"inline"},[_vm._v(_vm._s(investor.experiencePro))])]),_c('div',{staticClass:"col-span-2 pb-1"},[_c('h4',{staticClass:"inline pr-1 text-output-secondary"},[_vm._v(" Nombre d’années d’experience : ")]),_c('p',{staticClass:"inline"},[_vm._v(_vm._s(investor.yearsOfExperience))])])])])}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"inline pr-1 text-output-secondary"},[_c('i',{staticClass:"las la-phone text-output-secondary"}),_vm._v(" : ")])
},function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"inline pr-1 text-output-secondary"},[_c('i',{staticClass:"las la-at text-output-secondary"}),_vm._v(" : ")])
}]

export { render, staticRenderFns }